module.exports = __webpack_public_path__ + "static/media/smart_light.776640f0.png";